
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import HokCheckbox from '@hokify/shared-components/lib/components/HokCheckbox.vue';
import { PrivacyType } from '@hokify/shared-components/lib/types/privacyType';
import type { IAPILoginUser } from '@hokify/common';

const userStore = namespace('user/profile');

@Component({
	name: 'CheckPrivacyAlert',
	components: {
		HokCheckbox
	}
})
export default class CheckPrivacyAlert extends Vue {
	@userStore.State('obj') user!: IAPILoginUser;

	@userStore.Mutation('updatePrivacy') updatePrivacy;

	@userStore.Action('acceptPrivacy') acceptPrivacy;

	@Prop({
		type: String,
		default: 'company_digital_content',
		validator: (value: PrivacyType) => Object.values(PrivacyType).includes(value)
	})
	readonly privacyType!: string;

	privacyTypeAccepted = !!this.user?.privacy?.[this.privacyType];

	async continueDownload() {
		try {
			this.updatePrivacy({ [this.privacyType]: true });
			await this.acceptPrivacy(this.privacyType);
			this.$emit('privacy-accepted');
		} catch (err: any) {
			this.$errorHandler.call(this, err, 'Bedingungen konnten nicht akzeptiert werden.');
		}
	}
}
